import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { clearProfileInfo } from '../slices/profileSlice';
import { persistor } from '../store';

const LogoutWatcher = () => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const [userAuth, setUserAuth] = useState(() =>
    localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')) : null
  );
  const initialized = useRef(false)

  useEffect(() => {
    const checkLogoutCookie = () => {
      const logoutCookie = cookies.get("whmcs_logout");

      if (logoutCookie === "logout") {
        console.log("WHMCS Logout detected, clearing session...");
        console.log(process.env.REACT_APP_ENV);
        const domain = process.env.REACT_APP_ENV === "dev" ||  process.env.REACT_APP_ENV === "qa" ? ".neubox.xyz" : ".neubox.com";
        
        // Verifica que el dispatch se esté llamando
        console.log('Dispatching clearProfileInfo');
        dispatch(clearProfileInfo());

        // Limpia solo el perfil de la persistencia
        persistor.flush().then(() => {
            localStorage.removeItem('persist:profile'); // Elimina solo el perfil
            console.log('Estado de perfil eliminado de la persistencia');
            
            // Borra la cookie después de procesarla
            console.log('removing cookie');
            cookies.remove("whmcs_logout", { path: "/", domain: domain});
  
            // Limpia el localStorage
            localStorage.removeItem('userAuth');
            setUserAuth(null);
  
            // Recargar la página para que se reflejen los cambios
            window.location.reload();
          }).catch((error) => {
            console.error('Error purging persisted state', error);
          });
        
      }
    };
    if (!initialized.current) {
        initialized.current = true

        if (userAuth) {
            checkLogoutCookie();
        }
    }
  }, [dispatch, cookies]);


  return null;
};

export default LogoutWatcher;
